import { Button } from "antd";
import React, { Component } from "react";
import {
  Table,
  Tag,
  Menu,
  Dropdown,
  Form,
  message,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment-hijri";
import {
  FaArrowLeft,
  FaArrowRight,
  FaDownload,
  FaEllipsisH,
  FaEye,
  FaTrash,
  FaAngleRight,
  FaCloudUploadAlt,
  FaFilePdf,
} from "react-icons/fa";
import "./ClientBonds.scss";
import DeleteModal from "../DeleteModal/DeleteModal";
import {
  AddOrUpdateObligation,
  DeleteObligation,
  GetObligations,
  UploadMediationContractFile,
} from "../../network/request.network";
import { connect } from "react-redux";

class ClientBonds extends Component {
  formUserRef = React.createRef();

  state = {
    showAdd: false,
    showDltModal: false,
    showContact: false,
    tableLoading: false,
    loading: false,
    BondInfo: false,
    bondDetails: false,
    bondList: [],
    fileList: [],
  };

  componentDidMount() {
    this.handelGetObligations();
  }

  handelGetObligations = () => {
    this.setState({ tableLoading: true });
    let params = "";
    let { orderId } = this.props;
    params += `?FinancingRequestId=${orderId}`;
    GetObligations(
      params,
      (res) => {
        //console.log("resssss",res.data?.model)
        this.setState({ tableLoading: false, bondList: res.data.model });
      },
      (err) => {
        this.setState({ tableLoading: false });
      }
    );
  };

  handelAddBond = (values) => {
    this.setState({ loading: true });
    let body = { ...values };
    let { orderId } = this.props;

    body.FinancingRequestId = orderId;
    if (this.state.bondDetails) {
      body.Id = this.state.bondDetails.Id;
    }

    AddOrUpdateObligation(
      body,
      (res) => {
        // console.log(res.data);
        this.setState({ loading: false });
        if (this.state.bondDetails) {
          message.success("تم تعديل السند بنجاح");
        } else {
          message.success("تم اضافه السند بنجاح");
        }
        this.formUserRef.current.resetFields();
        this.setState({ showAdd: false });
        this.handelGetObligations();
      },
      (err) => {
        this.setState({ loading: false });
      }
    );
  };

  handeldeleteBond = () => {
    const { BondInfo } = this.state;
    this.setState({ tableLoading: true });
    DeleteObligation(
      BondInfo?.Id,
      (res) => {
        message.success("تم حذف المستند بنجاح");
        this.setState({
          bondList: this.state.bondList.filter(
            (ele) => ele.Id !== BondInfo?.Id
          ),
          tableLoading: false,
          showContact: false,
        });
      },
      (error) => {
        this.setState({ tableLoading: false });
      }
    );
  };

  handelChangeImg = (data) => {
    let { orderId } = this.props;
    this.setState({ tableLoading: true });
    let body = new FormData();
    body.append("FinancingRequestId", orderId);
    body.append("File", data.file);
    UploadMediationContractFile(
      body,
      (res) => {
        message.success("تمت إضافة المستند بنجاح");
        this.setState({ tableLoading: false });
        // this.setState({
        //     FinanceRequestFiles : [...this.state.FinanceRequestFiles, res.data.model]}, () => {
        //   this.handelAllFileUploadOrNot();
        // })
      },
      (error) => {
        // message.error("حدث خطأ أثناء معالجة المستند");
        this.setState({ tableLoading: false });
      }
    );
  };

  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="prev-page-btn pagin-page-btn">
          <FaArrowRight /> الصفحة السابقة{" "}
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="next-page-btn pagin-page-btn">
          الصفحة التاليه <FaArrowLeft />{" "}
        </a>
      );
    }
    return originalElement;
  };

  handelShowInfo = () => {
    this.setState({ showAdd: false });
  };

  closeDltModal = () => {
    this.setState({ showDltModal: false });
  };

  render() {
    const {
      showAdd,
      showDltModal,
      bondList,
      tableLoading,
      loading,
      bondDetails,
      showContact,
      fileList,
    } = this.state;
    const { ObligationReasons, Customer, userData } = this.props;

    return (
      <div className="client-info-wrapper">
        {showDltModal && (
          <DeleteModal
            delete={this.handeldeleteBond}
            name="السند"
            closeDltModal={this.closeDltModal}
          />
        )}

        {showContact ? (
          <>
            <header className="client-header">
              <h2 className="header-title"> السندات </h2>
            </header>

            <div className="client-bond-header">
              <Button
                type="text"
                size="large"
                className="text-black-btn"
                icon={<FaAngleRight />}
                onClick={() => this.setState({ showContact: false })}
              >
                &nbsp; عرض السند
              </Button>

              <div className="tab-title actions">
                <Button
                  type="text"
                  size="large"
                  className="text-blue-btn"
                  icon={<FaDownload />}
                  onClick
                >
                  &nbsp; تحميل
                </Button>

                <Button
                  type="text"
                  size="large"
                  className="text-red-btn"
                  icon={<FaTrash />}
                  onClick={() =>
                    this.setState({ showDltModal: true, BondInfo: bondDetails })
                  }
                >
                  &nbsp; حذف
                </Button>
              </div>
            </div>

            <div className="calc-summary-holder calc-summary-send-holder bond">
              <div className="summary-col">
                <div className="summary-info-row">
                  <p>رقم السند </p>
                  <h5>{bondDetails?.Id}</h5>
                </div>
                <div className="summary-info-row">
                  <p>رقم طلب التمويل</p>
                  <h5>{bondDetails?.FinancingRequestId}</h5>
                </div>
                <div className="summary-info-row">
                  <p>سبب السند </p>
                  <h5>{bondDetails?.ObligationReason.NameLT}</h5>
                </div>
                <div className="summary-info-row">
                  <p>قيمه السند </p>
                  <h5>{bondDetails?.Amount}</h5>
                </div>
                <div className="summary-info-row">
                  <p>مجدول للحذف؟ </p>
                  <h5>{bondDetails?.IsDeleted ? "نعم" : "لا"}</h5>
                </div>
              </div>

              <div className="summary-col">
                <div className="summary-info-row">
                  <p>رقم سند نافذ</p>
                  <h5>{bondDetails?.ObligationStatus.Id}</h5>
                </div>
                <div className="summary-info-row">
                  <p>حالة نافذ</p>
                  <Tag className="bond-status" color="gold">
                    {bondDetails?.ObligationStatus.NameLT}
                  </Tag>
                </div>
                <div className="summary-info-row">
                  <p>تاريخ الإنشاء</p>
                  <h5>
                    {moment
                      .utc(bondDetails?.CreationDate)
                      .local()
                      .format("iYYYY/iM/iD - HH:MM")}
                  </h5>
                </div>
                <div className="summary-info-row">
                  <p>تم الإنشاء بواسطة</p>
                  <h5>{bondDetails?.Employee?.AspNetUsers?.FullName}</h5>
                </div>
                {/* <div className="summary-info-row">
                      <p>الفريق</p>
                      <h5> مجموعة ابو سليمان</h5>
                    </div> */}
              </div>
            </div>
          </>
        ) : (
          <>
            <header className="client-header">
              <div className="client-bond-header">
                <h2 className="tab-title">السندات</h2>
                {/* <p
                      className="depts-add-btn"
                      onClick={() => {
                        this.setState({ showAdd: true, bondDetails: bondList[0]  })
                        setTimeout(() => {
                          this.formUserRef.current.setFieldsValue({
                            ObligationReasonId: bondDetails?.ObligationReasonId,
                            Amount: +bondDetails?.Amount, 
                          });
                        }, 300)
                      }}
                    >
                      <FaPlus /> إضافه سند جديد
                    </p> */}
              </div>
            </header>
            <div className="client-bond-content">
              <Table
                loading={tableLoading}
                editable
                bordered
                pagination={{ simple: true, itemRender: this.itemRender }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      this.setState({ showContact: true, bondDetails: record });
                    },
                  };
                }}
                rowKey="Id"
                className="table-roles-wrapper app-table-wrapper table-hover-wrapper order-table"
                columns={[
                  {
                    title: `رقم السند`,
                    dataIndex: "Id",
                  },
                  {
                    title: `رقم الطلب`,
                    dataIndex: "FinancingRequestId",
                  },
                  {
                    title: `سبب السند`,
                    dataIndex: "ObligationReason",
                    render: (text, record) => (
                      <div>{record?.ObligationReason?.NameLT}</div>
                    ),
                  },
                  {
                    title: `قيمه السند`,
                    dataIndex: "Amount",
                  },
                  {
                    title: "حاله نافذ",
                    key: "action",
                    className: "text-center",
                    render: (text, record) => (
                      <Tag className="contact-tag" color="cyan">
                        {record?.ObligationStatus?.NameLT}
                      </Tag>
                    ),
                  },
                  {
                    title: "اجراءت",
                    key: "action",
                    render: (text, record) => (
                      <Dropdown
                        overlayClassName="action-dropdown-holder"
                        trigger={["click"]}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        overlay={
                          <Menu>
                            <Menu.Item
                              className="show-item"
                              icon={<FaEye />}
                              onClick={() => {
                                this.setState({
                                  bondDetails: record,
                                  showContact: true,
                                });
                              }}
                            >
                              <p>عرض </p>
                            </Menu.Item>
                          </Menu>
                        }
                        placement="bottomLeft"
                      >
                        <div className="dropdown-icon-holder">
                          <FaEllipsisH />
                        </div>
                      </Dropdown>
                    ),
                  },
                ]}
                dataSource={bondList}
              />
            </div>
            <div className="cocuments-page">
              {userData?.MediationContractUrl ? (
                <div className="docs-holder">
                  <h6 className="docs-title">عقد الوساطة</h6>
                  <div className="doc-body">
                    <div className="browse-file-content">
                      <FaFilePdf />
                      <div className="browse-file-text">
                        <p>contract.pdf</p>
                        {/* <span>120.kb</span> */}
                      </div>
                    </div>
                    <div className="doc-action">
                      <a href={userData?.MediationContractUrl} target="_blank">
                        <FaEye style={{ color: "#C2A062" }} />
                      </a>
                      <a href={userData?.MediationContractUrl} target="_blank">
                        <FaDownload
                          style={{ color: "#06ACCC", margin: "0 14px" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                <Form
                  // className="form-add-content"
                  layout="horizontal"
                  name="nest-messages"
                >
                  <Form.Item
                    label="عقد الوساطة "
                    name="contactFile"
                    className="input-holder"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Upload
                      listType="picture"
                      // accept={file.MimeType}
                      maxCount={1}
                      onChange={(data) => this.handelChangeImg(data)}
                      action={null}
                      showUploadList={false}
                      beforeUpload={(data) => {
                        const reader = new FileReader();
                        reader.onload = (e) => {};
                        return false;
                      }}
                    >
                      <div className="btn-upload">
                        <div className="upload-btn-holder">
                          <div className="browse-file-content">
                            <FaCloudUploadAlt />
                            <div className="browse-file-text">
                              <p>قم بإسقاط الملف هنا </p>
                              <span>pdf</span>
                            </div>
                          </div>
                          <h5 className="browse-file-p">أو تصفح الملف</h5>
                        </div>
                      </div>
                    </Upload>
                  </Form.Item>
                </Form>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userRequest: state.user.userRequest,
  ObligationReasons: state.user.metaData.ObligationReasons,
});
export default connect(mapStateToProps)(ClientBonds);
